<div class="DocumentViewer-mobile">
  <!-- TOPICS -->
  <div class="Topics-container-mobile" *ngIf="featureFlagService.isTopicsContainerEnabled()">
    <icullen-topics [topics]="docData.topics"></icullen-topics>
  </div>
  <!-- TITLE -->
  <div class="DocumentTitle" *ngIf="!docData.hideTitleBanner && !docData.demo">
    <h1 [ngClass]="{'IsFavorite': isFavoriteDoc}">{{ docData.title }}</h1>
    <div class="OtherVersions-open" *ngIf="showOtherVersions()" (click)="openMobileOtherVersionsOnClick()"></div>
    <footer>
      <p>{{('uishared.regions.' + docData.regionCode) | transloco}} - {{ docData.creator }} - {{ docData.publicationDate }}</p> 
      <!-- BACK TO TOC -->
      <a *ngIf="docData.containingPublication" [routerLink]="'../' + docData.containingPublication" class="BackToToc">Back</a>
      <a *ngIf="shouldShowDatabaseButton(docData)" [routerLink]="'/site/case-database/' + docData.documentType.name" class="BackToToc">Back</a>
    </footer>
  </div>
  <!-- ACTION SIDEBAR COMPONENT -->
  <div *ngIf="!docData.demo" class="ActionSideBar ActionSideBar--onTop">
    <document-action-icons
      [data]="getActionIconsData(true)"
      (favoriteChanged)="onFavoriteChanged($event)"
      (pdfPrintButtonClicked)="addButtonClickAnalyticsData($event)">
    </document-action-icons>
  </div>
  <!-- BACK ON TOP // USED ONCE -->
  <ul class="BackOnTop">
    <li><a [routerLink]="['.']" fragment="MainNavigation" class="Top"></a></li>
    <li><a (click)="goBack()" class="Back"></a></li>
  </ul>
  <!-- DEMO MODE COMPONENT -->
  <document-demo-content
    *ngIf="docData.demo"
    [data]="docData">
    [partialAuth]="currentUser?.partialAuth"
    [company]="currentUser?.companyId">
  </document-demo-content>
  <!-- LOGIN -->
  <div class="Login" *ngIf="showLogin()">
    <button type="submit" class="Button" value="Login" (click)="login()">Login</button>
  </div>
  <!-- NOT DEMO MODE -->
  <div *ngIf="!docData.demo" class="DocumentContainer">
    <!-- MORE RECENT VERSION WARNING BOX COMPONENT -->
    <div *ngIf="!docData.latest" class="DocumentVersion alert alert-info" role="alert">
      <h3>
        <a [routerLink]="'/site/documents/' + docData.uniqueNumber">
          <b>A more recent version</b> of this document is available
        </a>
      </h3>
    </div>
    <!-- TABLE OF CONTENT // USED ONCE -->
    <div *ngIf="showTabs() && docData.documentType.name != 'PUBLICATION_BIG5'" class="TableOfContent">
      <h2>Content</h2>
      <ul>
        <li *ngFor="let anchor of docData.tabAnchors.tabAnchorList">
          <a pageScroll [pageScrollDuration]="0" href="#{{anchor.uid}}" *ngIf="anchor.sectionDtoType != 'TABLEVIEW'">{{ anchor.tabName }}</a>
          <a [routerLink]=" '../' + docData.uniqueNumber + '/table/fullView/' + anchor.uid" *ngIf="anchor.sectionDtoType === 'TABLEVIEW'" data-cy="tableView">{{ anchor.tabName }}</a>
        </li>
        <li *ngIf="docData.cullenPublicationDto && !docData.cullenPublicationDto.tableOfContentDto.execSummaryInToc">
          <a pageScroll [pageScrollDuration]="0" href="#TableOfContent">Table of content</a>
        </li>
      </ul>
    </div>
    <!-- TOC IN RR AND FLASHES -->
    <section-based-toc
      *ngIf="shouldShowSectionBasedToc(docData)"
      [docData]="docData"
      [isMobile]="true"
      [isSticky]="false">
    </section-based-toc>
    <!-- DOC CONTENT -->
    <div class="DocumentContent">
      <!-- IF BIG 5 -->
      <document-country-update-mobile
        *ngIf="docData.documentType.name === 'PUBLICATION_BIG5'"
        [tocCountryBased]="docData.cullenPublicationDto.tableOfContentDto.tocCountryBased">
      </document-country-update-mobile>
      <!-- IF NOT BIG 5 -->
      <ng-container *ngIf="docData.documentType.name != 'PUBLICATION_BIG5'">
        <article id="{{ tabContent.tabName }}" *ngFor="let tabContent of docData.tabAnchors.tabAnchorList; let i = index;">
          <!-- COMP LAW CASE HEADER -->
          <document-competition-law
            *ngIf="shouldShowCaseHeader(i, docData)"
            [keywords]="docData.keywords"
            [emphasisSections]="getEmphasisSectionsByTabName(tabContent.tabName)"
            [countryCode]="docData.countryCode"
            [calculatedValues]="docData.calculatedValues"
            [documentType]="docData.documentType.name"
            [infringements]="getInfrigements()"
            [aim]="getAim()"
            [target]="getTarget()"
            [dmaSubthemes]="getDmaSubthemes()"
            [dmaCps]="getDmaCps()"
            [dmaEmphasisSections]="getDmaEmphasisSectionsByTypeName(tabContent.tabName)">
          </document-competition-law>
          <!-- SECTIONS -->
          <document-section
            *ngFor="let section of getSectionsByTabName(tabContent.tabName);"
            [showSectionName]="tabContent.indexes.length > 1"
            [section]="section"
            [uniqueNumber]="docData.uniqueNumber"
            [documentType]="docData.documentType.name"
            [isMobile]="true"
            [tabName]="tabContent.tabName"
            [user]="currentUser.UserType">
          </document-section>
          <!-- TOC IN EXISTING TAB -->
          <document-toc-container
            *ngIf="docData.cullenPublicationDto && docData.cullenPublicationDto.tableOfContentDto.execSummaryInToc"
            [tocType]="docData.cullenPublicationDto.tocType"
            [pillars]="docData.cullenPublicationDto.tableOfContentDto.tocPillars"
            [groups]="docData.cullenPublicationDto.tableOfContentDto.groups"
            [newIndicatorDays]="docData.cullenPublicationDto.tableOfContentDto.newIndicatorDays">
          </document-toc-container>
        </article>
        <!-- TOC IN NEW TAB -->
        <article id="TableOfContent" *ngIf="docData.cullenPublicationDto && !docData.cullenPublicationDto.tableOfContentDto.execSummaryInToc">
          <document-toc-container
            [tocType]="docData.cullenPublicationDto.tocType"
            [pillars]="docData.cullenPublicationDto.tableOfContentDto.tocPillars"
            [groups]="docData.cullenPublicationDto.tableOfContentDto.groups"
            [newIndicatorDays]="docData.cullenPublicationDto.tableOfContentDto.newIndicatorDays">
          </document-toc-container>
        </article>
      </ng-container>
    </div>
    <!-- ATTACHMENT -->
    <div class="Attachment" *ngIf="docData.collectionAttachments">
      <h2 *ngIf="docData.authority">{{('uishared.authority.' + docData.authority) | transloco}}</h2>
      <header>
        <h3>{{docData.collectionAttachments.attachments.length}} <span [innerText]="getAttachmentsTitle(docData.collectionAttachments.attachments.length)"></span></h3>
        <a href="/product/attachments/{{docData.uniqueNumber}}.zip">Download</a>
      </header>
      <ul class="PdfList">
        <li *ngFor="let attachment of docData.collectionAttachments.attachments">
          <a href="/product/binarydocs/{{attachment.id}}" target="fromDocViewer">
            <h4>{{attachment.name}}</h4>
            <p *ngIf="attachment.description">{{attachment.description}}</p>
          </a>
        </li>
      </ul>
    </div>
    <ng-container *ngIf="docData.hideTitleBanner === false">
      <!-- ACTION SIDEBAR COMPONENT -->
      <div *ngIf="!docData.demo" class="ActionSideBar">
        <document-action-icons
          [data]="getActionIconsData(true)"
          (favoriteChanged)="onFavoriteChanged($event)"
          (pdfPrintButtonClicked)="addButtonClickAnalyticsData($event)">
        </document-action-icons>
      </div>
      <!-- RELATED POST COMPONENT -->
      <div class="RelatedDocs">
        <related-docs *ngIf="docData.relatedDocuments.length > 0" [relatedDocuments]="docData.relatedDocuments" [docType]="docData.documentType.name"></related-docs>
        <!-- SIMILAR POSTS -->
        <similar-docs *ngIf="similarDocs?.length > 0 && docData.publication === false" [similarDocuments]="similarDocs"></similar-docs>
      </div>
    </ng-container>
    <!-- OTHER VERSIONS // USED ONCE -->
    <div id="OtherVersions" class="OtherVersions OtherVersions--mobile" *ngIf="showOtherVersions()" [ngClass]="mobileOtherVersionsAreOpen ? 'Active' : ''">
        <h2>{{docData.versions.length}} other versions</h2>
        <div class="OtherVersions-close" (click)="closeMobileOtherVersionsOnClick()"></div>
        <ul class="OtherVersions-list">
          <li *ngFor="let version of docData.versions" [ngClass]="{'Active': activeAccordeon === version, 'Selected': docData.uniqueNumber === version.uniqueNumber}" (click)="showAccordeonOnClick(version)">
            <other-version-mobile [versionDoc]="version" [currentVersionUniqueNumber]="docData.uniqueNumber"></other-version-mobile>
          </li>
        </ul>
    </div>
  </div>
</div>
